var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('HeaderApp'),_c('MenuApp'),(_vm.validatingToken)?_c('LoadingPage'):_c('ContentApp'),_c('FooterApp')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }